import { DefaultRouteTabs } from '@/components/_common';
import SpedDocumentList from '@/components/Fiscal/Sped/SpedDocumentList';
import SpedDocumentCreateButton from '@/components/Fiscal/Sped/SpedDocumentCreateButton';
import { PageProps } from '@/types/PageProps';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

export default function SpedDocumentsPage({ route }: PageProps) {
  const intl = useIntl();

  return (
    <DefaultRouteTabs
      permissions={route.permissions}
      route={route.parent}
      persistSearchParams={false}
      extra={<SpedDocumentCreateButton />}
    >
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <SpedDocumentList />
    </DefaultRouteTabs>
  );
}
